import { render, staticRenderFns } from "./FormEmail.vue?vue&type=template&id=2de70815&scoped=true&"
import script from "./FormEmail.vue?vue&type=script&lang=tsx&"
export * from "./FormEmail.vue?vue&type=script&lang=tsx&"
import style0 from "./FormEmail.vue?vue&type=style&index=0&id=2de70815&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de70815",
  null
  
)

export default component.exports